import { useNavigate } from "react-router-dom";

import APIconButton from "./APIconButton";

const RefreshButton = ({ onClick }: { onClick?: () => Promise<void> }) => {
  const navigate = useNavigate();

  const onRefresh = async () => {
    onClick && (await onClick());

    navigate(0);
  };

  return <APIconButton iconName="refresh" onClick={onRefresh} />;
};

export default RefreshButton;
